<template>
  <v-dialog :value="value" max-width="520" @input="$emit('input', $event)">
    <v-card class="point_picker_dialog">
      <div class="point_picker_dialog__header">
        <div>
          <h4>{{ $t("PLACEHOLDERS.same_location_points_title") }}</h4>
          <p>{{ $t("PLACEHOLDERS.choose_distribution_point_hint") }}</p>
        </div>
        <button type="button" class="close_btn" @click="$emit('input', false)">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="point_picker_dialog__list">
        <button
          v-for="point in points"
          :key="point.id"
          type="button"
          class="point_picker_item"
          @click="$emit('select', point)"
        >
          <div class="point_picker_item__main">
            <strong>{{ getPointLabel(point) }}</strong>
            <span>{{ point.mobile || "-" }}</span>
          </div>
          <div class="point_picker_item__meta">
            <span>#{{ point.id }}</span>
            <i class="fas fa-chevron-left"></i>
          </div>
        </button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { getDistributionPointLabel } from "../utils/delegatesMapHelpers";

export default {
  name: "DistributionPointPickerDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    points: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    getPointLabel: getDistributionPointLabel,
  },
};
</script>
